<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">标签分发</div>
      <div class="top">
        <Button class="newBotton" @click="inAddVal()">
          <span class="newBottonText">新增</span>
        </Button>
        <div class="select">
          <Input
            v-model="selectVal"
            @on-search="select()"
            search
            placeholder="输入编号、名称、号段回车"
          />
        </div>
        <div class="select" style="line-height: 35px">
          共 {{ allPage }} 条记录
        </div>
      </div>
      <div class="main mains">
        <el-empty description="没有数据哦！" v-if="pageData.length == 0" />
        <Table
          border
          :columns="columns"
          :data="pageData"
          style="width: 100%"
          v-if="pageData.length !== 0"
        >
          <template #states="{ row }">
            <strong v-if="row.state == 1" style="color: green">已启用</strong>
            <strong v-else style="color: red">已禁用</strong>
          </template>
          <template #serial="{ row, index }">
            {{ row.serial_head }} - {{ row.serial_end }}
          </template>
          <template #action="{ row, index }">
            <!-- <Button style="margin-right: 5px" @click="show(index)">修改</Button> -->
            <Button v-if="row.state == 1" type="warning" @click="updataDispence(row,0)" >禁用</Button >
            <Button v-else type="success" @click="updataDispence(row,1)">启用</Button>

            <Button style="margin-left: 5px" type="error" @click="remove(index)"
              >删除</Button
            >
          </template>
        </Table>
        <!-- 分页 -->
        <Page
          class="page"
          :modelValue="pages"
          :total="allPage"
          simple
          @on-change="page"
        />
      </div>

      <Drawer
        title="添加分发信息"
        :closable="false"
        v-model="addVal"
        width="600"
      >
        <NewDispense @close="NewFiledClose"></NewDispense>
      </Drawer>
    </div>
  </div>
</template>
<script>
import NewDispense from "@/views/dispense/newDispense";
import { GetDispenseList, DelDispense, UpDispense } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      value: false,
      addVal: false,
      cityList: [
        {
          value: 1,
          name: "启用",
        },
        {
          value: 0,
          name: "禁用",
        },
      ],
      columns: [
        // {
        //   title: "ID",
        //   key: "id",
        //   width: 80,
        // },
        {
          title: "企业代码",
          key: "clientcode",
          width: 100,
        },
        {
          title: "代理商编号",
          key: "client_id",
          width: 200,
        },
        {
          title: "代理商名称",
          key: "client_name",
          width: 200,
        },
        {
          title: "产品名称",
          key: "product_name",
          width: 200,
        },
        {
          title: "分发号段",
          key: "serial_head",
          slot: "serial",
          width: 200,
        },
        // {
        //   title: "结束号段",
        //   key: "serial_end",
        //   width: 200,
        // },
        {
          title: "创建时间",
          key: "time",
          width: 200,
        },
        {
          title: "状态",
          key: "state",
          slot: "states",
          width: 90,
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 200,
        },
        {
          title: " ",
          slot: "action",
          width: 170,
          align: "center",
          fixed: "right",
        },
      ],
      // 分页后的数据
      pageData: [],
      pages: 1,
      allPage: 1,
      index: "",
    };
  },
  components: {
    NewDispense,
  },
  created() {
    let control = this.$store.state.control;
    if (control !== "1") {
      this.columns = this.columns.filter((p, key) => {
        if (p.title !== "企业代码") {
          return p;
        }
      });
    }

    this.getDispese();
  },
  methods: {
    updataDispence(index, state) {
      UpDispense({
        id: index.id,
        name: state,
      }).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.getDispese()
        }
      });
    },
    // 搜索
    select() {
      this.getDispese();
    },
    // 获取分发资料
    getDispese() {
      GetDispenseList({
        code: 1,
        page: this.pages,
        pagesize: 10,
        name: this.selectVal,
      }).then((res) => {
        // 初始列表过滤10
        this.pageData = res.list;
        this.allPage = res.size;
      });
    },
    // 添加成功
    NewFiledClose() {
      this.addVal = false;
      this.getDispese();
      this.$message({
        type: "success",
        message: "添加成功!",
      });
    },
    //点击添加按钮
    inAddVal(index) {
      this.addVal = true;
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      this.getDispese();
    },
    // 删除按钮
    remove(index) {
      const title = this.pageData[index].client_name;
      const id = this.pageData[index].id;
      this.$confirm("此操作将永久删除该" + title + "字段, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 提交删除请求
          DelDispense({
            id,
          }).then((res) => {
            if (res.code == 402) {
              this.$Notice.error({ title: "没有权限！" });
            }
            if (res == 1) {
              this.getDispese();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败！",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
